import { PrintSiteRef } from '../../core/models/reference.model';

const mockPrintSites: PrintSiteRef[] = [
  { id: 1, printSiteName: 'Site A - East Coast', isActive: true },
  { id: 2, printSiteName: 'Site B - West Coast', isActive: true },
  { id: 3, printSiteName: 'Site C - Central', isActive: true },
  { id: 4, printSiteName: 'Site D - Southeast', isActive: true },
  { id: 5, printSiteName: 'Site E - Northwest', isActive: true },
  { id: 6, printSiteName: 'Site F - Midwest (Legacy)', isActive: false },
];

export function getMockPrintSites(includeInactive = false): PrintSiteRef[] {
  if (includeInactive) {
    return [...mockPrintSites];
  }
  return mockPrintSites.filter(site => site.isActive);
}

export function getMockPrintSiteById(id: number): PrintSiteRef | null {
  return mockPrintSites.find(site => site.id === id) ?? null;
}
